import API from 'utils/api';
import { onError } from 'utils/handlers';
import { setBancos } from 'store/catalogos';

/**
 * GET Bancos
 * @param {object} paramas
 */
// eslint-disable-next-line import/prefer-default-export
export const getBancos = async (dispatch, bancos) => {
  try {
    if (bancos?.length) {
      return bancos;
    }
    const response = await API.get('/configuraciones/bancos/');
    if (dispatch) {
      dispatch(setBancos(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
